if (!customElements.get('review-video-cards')) {
  customElements.define('review-video-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.videos = Array.from(this.querySelectorAll('video'));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) entry.target.pause();
        });
      });
      this.videos.forEach(video => {
        const button = video.parentElement.querySelector('.review-video-cards__play');
        // The customer name overlay is hidden while native controls are on screen.
        const setActive = on => video.parentElement.classList.toggle('is-playing', on);
        video.controls = false;
        button.hidden = false;
        button.addEventListener('click', () => {
          video.controls = true;
          setActive(true);
          button.hidden = true;
          video.focus();
          video.play().catch(() => {
            // Keep native controls available to retry playback or inspect an error.
            button.hidden = false;
          });
        }, options);
        video.addEventListener('play', () => {
          setActive(true);
          button.hidden = true;
          document.querySelectorAll('review-video-cards video').forEach(other => {
            if (other !== video) other.pause();
          });
        }, options);
        video.addEventListener('ended', () => {
          video.controls = false;
          setActive(false);
          button.hidden = false;
        }, options);
        this.observer.observe(video);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
      this.initSwiper(this.events.signal);
    }

    async initSwiper(signal) {
      const Swiper = window.Swiper || await window.swiperReady;
      if (!Swiper || signal.aborted || !this.isConnected) return;
      const styles = getComputedStyle(this);
      const columns = Number(styles.getPropertyValue('--rvc-columns')) || 5;
      const gap = parseFloat(styles.getPropertyValue('--rvc-gap')) || 0;
      const mobileGap = parseFloat(styles.getPropertyValue('--rvc-gap-mobile')) || 0;
      const navigation = this.querySelector('[data-navigation]');
      const updateNavigation = swiper => { navigation.hidden = swiper.isLocked; };
      this.swiper = new Swiper(this.querySelector('[data-viewport]'), {
        slidesPerView: 1.15,
        spaceBetween: mobileGap,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350,
        watchOverflow: true,
        watchSlidesProgress: true,
        grabCursor: true,
        navigation: {
          prevEl: this.querySelector('[data-prev]'),
          nextEl: this.querySelector('[data-next]')
        },
        a11y: { enabled: true, slideRole: 'listitem', prevSlideMessage: 'Previous video review', nextSlideMessage: 'Next video review' },
        breakpoints: {
          750: { slidesPerView: Math.min(3, columns), spaceBetween: 20 },
          1200: { slidesPerView: columns, spaceBetween: gap }
        },
        on: {
          init: updateNavigation,
          lock: updateNavigation,
          unlock: updateNavigation,
          slideChange: () => this.videos.forEach(video => video.pause())
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.swiper-slide');
        const index = Array.from(this.swiper.slides).indexOf(slide);
        if (index >= 0) this.swiper.slideTo(index);
      }, { signal });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.videos?.forEach(video => video.pause());
    }
  });
}
